// removed by extract-text-webpack-plugin
module.exports = {"card":"time-poll-card__card__3zkVh","card__location":"time-poll-card__card__location__vX-BA","card__title":"time-poll-card__card__title__-hsOl","card__title--active":"time-poll-card__card__title--active__1AlkR","card__title--closed":"time-poll-card__card__title--closed__1X3Ke","card__text":"time-poll-card__card__text__3VEr8","card__info":"time-poll-card__card__info__1Xl2L","card__user":"time-poll-card__card__user__Zw2bo","icon":"time-poll-card__icon__nSbDN","profile":"time-poll-card__profile__3drJR"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/time-poll/TimePollContainer/TimePoll/TimePollCard/time-poll-card.scss
// module id = 1775
// module chunks = 1